import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketScrappageDetailsTemplate from './BasketScrappageDetailsTemplate';
import { rem } from 'polished';

export const BasketScrappageDetailsStyled = styled(BasketScrappageDetailsTemplate)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .Collapsible__contedescriptionntInner {
        padding-bottom: ${rem(30)};
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .description {
        span {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            display: block;
            padding-bottom: ${rem(8)};
        }

        .link {
            text-decoration: underline;
            cursor: pointer;
            background: none;
            border: none;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            padding: 0;
        }
    }

    .summary {
        margin: ${rem(20)} 0;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }

        .leftSection,
        .rightSection {
            width: 100%;

            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }
        }

        .leftSection {
            font-size: ${({ theme }) => theme.fontSizes.textBase};

            p {
                padding-bottom: ${rem(20)};
            }

            @media (min-width: ${breakpoints.md}px) {
                margin: 0 ${rem(8)} 0 0;
            }
        }

        .rightSection {
            p {
                display: flex;
                justify-content: space-between;
                border-top: 1px solid ${({ theme }) => theme.colors.grey25};
                padding: ${rem(12)} ${rem(12)} 0 ${rem(12)};

                .price {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                }
            }
            @media (min-width: ${breakpoints.md}px) {
                margin: 0 0 0 ${rem(8)};
            }
        }

        .totalPrice {
            padding: ${rem(12)} !important;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};
        }
    }

    .spinner {
        margin: ${rem(10)} auto;
        padding: 0;
    }
`;
